import AdmProducts from './AdmProducts';

export default AdmProducts;